import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Dashboard from "@/pages/Dashboard";
import Tickets from "@/pages/Tickets";
import CreateTicket from "@/pages/CreateTicket";
import TicketDetail from "@/pages/TicketDetail";
import KnowledgeBase from "@/pages/KnowledgeBase";
import Admin from "@/pages/Admin";
import Settings from "@/pages/Settings";
import Trash from "@/pages/Trash";
import Board from "@/pages/Board";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import CSATSurvey from "@/pages/CSATSurvey";
import HallOfFame from "@/pages/HallOfFame";
import { LanguageProvider } from "@/lib/i18n";
import { ThemeProvider } from "@/lib/theme";

function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/csat/:token" element={<CSATSurvey />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/tickets" element={<Tickets />} />
        <Route
          path="/board"
          element={
            <ProtectedRoute roles={["agent", "team_leader", "admin", "manager"]}>
              <Board />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customers"
          element={
            <ProtectedRoute roles={["agent", "team_leader", "admin", "manager"]}>
              <Customers />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customers/:id"
          element={
            <ProtectedRoute roles={["agent", "team_leader", "admin", "manager"]}>
              <CustomerDetail />
            </ProtectedRoute>
          }
        />
        <Route path="/tickets/new" element={<CreateTicket />} />
        <Route path="/tickets/:id" element={<TicketDetail />} />
        <Route path="/kb" element={<KnowledgeBase />} />
        <Route
          path="/hall-of-fame"
          element={
            <ProtectedRoute roles={["agent", "team_leader", "admin", "manager"]}>
              <HallOfFame />
            </ProtectedRoute>
          }
        />
        <Route path="/settings" element={<Settings />} />
        <Route
          path="/trash"
          element={
            <ProtectedRoute roles={["admin"]}>
              <Trash />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute roles={["admin"]}>
              <Admin />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <ThemeProvider>
            <AuthProvider>
              <AppRouter />
              <Toaster />
            </AuthProvider>
          </ThemeProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
